<template>
  <div>
    <div class="bg-white shadow-lg pt-5 pb-3 my-3" style="border-radius: 20px">
      <div :id="chart_id"></div>
    </div>
  </div>
</template>

<script>
import {pspLabelVariant, totalOptions} from "@/constants/ApexChartOptions";
import {i18n} from "@/plugins/i18n";
import ApexCharts from "apexcharts";

export default {
  name: "monthly-transaction-chart-based-psp",
  props: {
    chart_data: {
      default() {
        return {}
      }
    },
    chart_id: {
      type: String,
      required: true,
    },
    chart_base: {
      type: String,
      required: true
    },
  },
  methods: {
    fillOptions() {
      totalOptions.colors = this.fillColors()
      totalOptions.series = this.fillSeries()
      try {
        totalOptions.yaxis.title.text = ''
      } catch (e) {
        totalOptions.yaxis[0].title.text = ''
      }
      totalOptions.xaxis.categories = this.fillDateAxis()
    },
    fillSeries() {
      let data = []
      let transactions = (this.chart_base == 'price') ? this.chart_data.succeeded : this.chart_data.succeeded_count

      Object.keys(transactions).forEach(function (psp) {
        let object = {
          name: i18n.t('psp_list.' + psp.toLowerCase()),
          data: transactions[psp],
        }
        data.push(object)
      })
      return data
    },
    fillColors() {
      let data = []
      let transactions = (this.chart_base == 'price') ? this.chart_data.succeeded : this.chart_data.succeeded_count
      Object.keys(transactions).forEach(function (psp) {
        data.push(pspLabelVariant.get(psp.toLowerCase()))
      })
      return data
    },
    fillDateAxis() {
      let data = []
      let axis = this.chart_data.axis
      Object.keys(axis).forEach(function (item) {
        data.push(axis[item])
      })
      return data
    }
  },
  mounted() {
    this.fillOptions()
    let chart = new ApexCharts(document.querySelector("#" + this.chart_id), totalOptions);
    chart.render();
  },
}
</script>

<style scoped>

</style>